import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ClinicSubscriptionsApi } from '../../../apis/ClinicSubscriptionsApi/ClinicSubscriptionsApi';
import { IUpdateClinicSubscription } from '../ClinicSubscription';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';

export const useUpdateClinicSubscription = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ subscriptionId, data }: { subscriptionId: string; data: IUpdateClinicSubscription }) => 
            ClinicSubscriptionsApi.updateSubscription(subscriptionId, data),
        onSuccess: () => {
            // Invalidate clinic seat usage related queries
            queryClient.invalidateQueries({ queryKey: [QueryKeys.clinicSeatUsage] });
            queryClient.invalidateQueries({ queryKey: [QueryKeys.healthcareFacility] });
            // Also invalidate the all clinic seat usages query
            queryClient.invalidateQueries({ queryKey: [QueryKeys.clinicSeatUsage, 'all'] });
        },
    });
};

